import React from 'react';
import {Container, Row, Col } from '@bootstrap-styled/v4';
import {FaqSection,FaqHeadingWrapper,FaqSectionHeading,FaqSectionSubHeading,
    FaqAccordianWrapper} from './faq.style'
import AccordianCustom from './AccordianCustom';
import Fade from 'react-reveal/Fade';
import { useStaticQuery, graphql } from 'gatsby';

  
const Faq =()=>{
    const JSONData  = useStaticQuery(graphql`
        query{
            saasJson {
                FAQ {
                    DelayConstant
                    FaqSectionHeading
                    FaqSectionSubHeading
                    AccordianCustom{
                        title
                        description
                    }
                }
            }
        }
    `);
    return (
        <FaqSection id="faqContainer">
            <Container>
                <FaqHeadingWrapper>
                    <Row>
                        <Col md="12">
                            <Fade bottom delay={1*JSONData.saasJson.FAQ.DelayConstant}>
                                <FaqSectionHeading>{JSONData.saasJson.FAQ.FaqSectionHeading}</FaqSectionHeading>
                            </Fade>
                        </Col>
                    </Row>
                </FaqHeadingWrapper>
                <Fade bottom delay={1*JSONData.saasJson.FAQ.DelayConstant}>
                    <FaqAccordianWrapper>
                        <Row>
                            <Col md="12">
                            {
                                JSONData.saasJson.FAQ.AccordianCustom.map((item,idx) => {
                                return <AccordianCustom
                                    key={idx}
                                    title={item.title}
                                    description= {item.description} 
                                />
                                })
                            }
                            </Col>
                        </Row>
                    </FaqAccordianWrapper>
                </Fade>
            </Container>
        </FaqSection>
    );
}
export default Faq;